import React from 'react';
import SmpImg from '../projects-img/Screenshot 2023-05-31 144456.png'
import RentImg from '../projects-img/Screenshot 2023-05-31 144324.png'
import TellImg from '../projects-img/Screenshot 2023-05-31 143731.png';
import MetflixImg from '../projects-img/Screenshot 2023-06-01 002002.png';
import DisneyImg from '../projects-img/Screenshot 2023-06-01 001909.png';
import TeslaImg from '../projects-img/Screenshot 2023-06-01 001333.png';
import NftImg from '../projects-img/Screenshot 2023-06-01 002105.png';
import BootStrapImg from '../projects-img/Screenshot 2023-06-01 013610.png';
import AmazonImg from '../projects-img/Screenshot 2023-06-01 014109.png';
import PromptImg from '../projects-img/Screenshot 2023-07-10 141407.png';
import Carshow from '../projects-img/CarShow.png';
import Hotel from '../projects-img/Hotel.png';
import Probithub from '../projects-img/ProbitHub.png';
import Telegrafi from '../projects-img/Telegrafi.png';


const Projects = () => {
  //  te dhenat e projekteve 
  const projects = [
    {
      title: 'SMP',
      description: 'This project is about a system that can efficiently manage employee work and their projects. It has been developed using PHP, jQuery, and MySQL. The system features two main user roles: Administrator and Regular Worker.',
      image: `${SmpImg}`,
      link:'http://mehmet-govori.rf.gd/',
      gitLink:'https://github.com/Metigovori/SMP-Project',
    },
    {
      title: 'Rent A Car',
      description: 'This project focuses on a Rent a Car brand and provides a comprehensive system to manage various aspects of the business. The system has been developed using PHP, jQuery, and MySQL, ensuring a robust and reliable foundation. It offers two main user roles: Administrator and Regular Worker.',
      image: `${RentImg}`,
      link:'http://rentacar.infinityfreeapp.com/',
      gitLink:'https://github.com/Metigovori/Rent-A-Car-Project',
    },
    {
      title: 'Wallpapers Web',
      description: 'This project is a fully functional website that allows users to explore, post, comment on, and download wallpapers. It has been developed using Next.js, Figma, Tailwind CSS, and the Sanity database system, and is deployed with Netlify. ',
      image: `${TellImg}`,
      link:'https://640f175e7eccd473c90f51c1--tellyou.netlify.app/login',
      gitLink:'https://github.com/Metigovori/Tell-You-Wallpaper-App',
    },
     {
      title: 'Promptopia',
      description: "Introducing Promptopia: AI-powered writing companion. Get inspired with endless writing prompts generated by AI. Built with Next.js, designed with Figma, styled with Tailwind CSS, and deployed on Vercel. Unleash your creativity and overcome writer's block. Join Promptopia and explore a world of limitless writing possibilities.",
      image: `${PromptImg}`,
      link:'https://project-promptopia-neon.vercel.app/',
      gitLink:'https://github.com/Metigovori/project_promptopia',
    },
    {
      title: 'Hotel & Mangment System',
      description: "The Hotel Management Hub is a comprehensive full-stack web application developed using Object-Oriented PHP and MySQL, designed to streamline hotel operations and enhance guest experiences. With separate admin and client interfaces, the platform offers seamless management of newsletters and reservations, catering to both hotel staff and valued guests.",
      image: `${Hotel}`,
      link:'https://github.com/Metigovori/Hotel.git',
      gitLink:'https://github.com/Metigovori/Hotel.git',
    },
    {
      title: 'Probit Hub',
      description: "ProBit Hub is an innovative web platform created using Object-Oriented PHP with Eloquent ORM and MySQL, designed to empower students in their pursuit of academic excellence. By harnessing the power of artificial intelligence, ProBit Hub enables students to generate high-quality questions tailored to their learning objectives, ultimately enhancing their understanding and preparation for assessments.",
      image: `${Probithub}`,
      link:'https://github.com/Metigovori/ProbitHub.git',
      gitLink:'https://github.com/Metigovori/ProbitHub.git',
    },
    {
      title: 'Rent A Car',
      description: "Rent-a-Car is a modern web application developed using Next.js and TypeScript, designed to revolutionize the car rental experience. By leveraging public APIs, this platform offers users a user-friendly interface to browse, select, and rent vehicles with ease, enhancing convenience and efficiency.",
      image: `${Carshow}`,
      link:'https://github.com/Metigovori/Car-Showcase.git',
      gitLink:'https://github.com/Metigovori/Car-Showcase.git',
    },
    {
      title: 'Telegrafi Clone ',
      description: "The Telegrafi Clone is a web application that emulates the renowned news website by harnessing PHP and public APIs to retrieve and display up-to-date news articles. By mimicking the look and functionality of the original site, this clone offers users a familiar platform to access a curated selection of news content from various sources.",
      image: `${Telegrafi}`,
      link:'https://github.com/Metigovori/telegrafi_clone.git',
      gitLink:'https://github.com/Metigovori/telegrafi_clone.git',
    },
    {
      title: 'Amazon Clone',
      description: 'This full stack project is built with React and incorporates various technologies and functionalities to deliver a seamless user experience. The project utilizes ContextAPI, Cloud Functions, Firebase, and Stripe payments.',
      image: `${AmazonImg}`,
      link:'https://challange-60c9b.web.app/',
      gitLink:'https://github.com/Metigovori/Amazon',
    },
    {
      title: 'Tesla Web Clone',
      description: 'This project is a stunning clone of the Tesla website, meticulously crafted using React, Redux, and Styled Components. It captures the essence of the original Tesla website while providing an immersive and interactive user experience.',
      image: `${TeslaImg}`,
      link:'https://tesla-clone-74179.web.app/',
      gitLink:'https://github.com/Metigovori/MyTeslaWeb',
    },
    {
      title: 'Disney Web Clone',
      description: 'Welcome to the captivating world of the Disney website clone! This exceptional project is crafted using Redux,Firebase and Styled Components, bringing the enchantment of Disney right to your screen.',
      image: `${DisneyImg}`,
      link:'https://projektidisney.web.app/home',
      gitLink:'https://github.com/Metigovori/DisneyCode',
    },
    {
      title: 'Nft app',
      description: 'Welcome to the NFT app powered by Three.js! Immerse yourself in a captivating experience where 3D objects come to life, showcasing the limitless possibilities of non-fungible tokens.',
      image: `${NftImg}`,
      gitLink:'https://github.com/Metigovori/NFT-Web-ThreeJS',
    },
    {
      title: 'Netflix Clone',
      description: 'Welcome to my impressive portfolio project, the Netflix clone! Immerse yourself in the world of entertainment with this meticulously crafted application, developed using React and Redux.',
      image: `${MetflixImg}`,
      gitLink:'https://github.com/Metigovori/Netflix-Clone',
    },
    {
      title: 'Social Media',
      description: 'A project made entirely with BootStrap',
      image: `${BootStrapImg}`,
      gitLink:'https://github.com/Metigovori/Social-Media-Bootstrap',
    },
  ];

  return (
    <div className="container mt-5">
      <h2 className="text-center mb-4 text-light">Projects</h2>
      <div className="row">
        {projects.map((project, index) => (
          <div className="col-md-4" key={index}>
            <div className="card mb-4">
              <img
                src={project.image}
                className="card-img-top"
                alt={project.title}
              />
              <div className="card-body">
                <h5 className="card-title">{project.title}</h5>
                <p className="card-text">{project.description}</p>
                <a href={project.link} className="btn btn-primary">
                  View Details
                </a>
                <a href={project.gitLink} className="btn btn-dark ms-4">
                  View Code
                </a>
              </div>
            </div>
          </div>

          
        ))}
      </div>
    </div>
  );
};

export default Projects;
